import React from "react";
import { PieChart, Pie } from "recharts";

const wrapText = (text, maxWidth) => {
  const words = text.toString().split(" ");
  const lines = [];
  let currentLine = words[0];

  for (let i = 1; i < words.length; i++) {
    if (currentLine.length + words[i].length + 1 <= maxWidth) {
      currentLine += " " + words[i];
    } else {
      lines.push(currentLine);
      currentLine = words[i];
    }
  }
  lines.push(currentLine);
  return lines;
};

const CustomLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  name,
  value,
  percentage,
  fill,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = outerRadius + 30;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  const labelText = percentage !== undefined 
  ? `${name}: ${value} ${percentage}%` 
  : `${name}: ${value}`;
  const lines = wrapText(labelText, 20);

  return (
    <g>
      {lines.map((line, index) => (
        <text
          key={index}
          x={x}
          y={y + index * 15}
          fill={fill} // Using the same color as the pie slice
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
          fontSize={10}
        >
          {line}
        </text>
      ))}
    </g>
  );
};

export default function PieChartWithDescription({ data }) {
  const chartWidth = 900;
  const chartHeight = 350;
  const centerX = chartWidth / 2;
  const centerY = chartHeight / 2;

  return (
    <PieChart width={chartWidth} height={chartHeight}>
      <Pie
        data={data}
        dataKey="value"
        cx={centerX}
        cy={centerY}
        innerRadius={0}
        outerRadius={80}
        labelLine={true}
        label={<CustomLabel />}
      />
    </PieChart>
  );
}
